import { useConnections } from '../../hooks/useConnections';
import { SharePointConnection } from './SharePointConnection';
import { AIConnection } from './AIConnection';

export function ConnectionsManager() {
  const { loading, reload, getConnectionByType } = useConnections();

  const sharepointConnection = getConnectionByType('sharepoint');
  const aiConnection = getConnectionByType('ai');

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Connections</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage integrations with external services
        </p>
      </div>
      
      <div className="space-y-6">
        <SharePointConnection
          connection={sharepointConnection}
          onUpdate={reload}
        />

        <AIConnection
          connection={aiConnection}
          onUpdate={reload}
        />
      </div>
    </div>
  );
}

